export default __webpack_public_path__ + "static/media/store.e414e931.svg";